// Velo API Referansı: https://www.wix.com/velo/reference/api-overview/introduction

import wixData from 'wix-data';
import wixUsers from 'wix-users';

$w.onReady(function () {
  $w('#addToCartButton').onClick(() => {
    const name = $w('#customName').value;
    const font = $w('#fontSelect').value;
    const packageOption = $w('#giftPackage').value;

    const user = wixUsers.currentUser;
    const userId = user.id;

    if (!name || name.length > 12) {
      console.log("Lütfen geçerli bir isim girin (maks. 12 karakter).");
      return;
    }

    user.getEmail()
      .then((email) => {
        wixData.insert("Customizations", {
          name: name,
          font: font,
          packageOption: packageOption,
          userId: userId,
          userEmail: email
        })
        .then(() => {
          console.log("Kişiselleştirme bilgileri e-posta ile birlikte kaydedildi.");
        })
        .catch((err) => {
          console.error("Veritabanına kayıt hatası:", err);
        });
      })
      .catch((err) => {
        console.error("E-posta alınamadı:", err);
      });
  });
});
